export { default } from '../upgrad-to-hardcopy';
